import type {
  ButtonLinkProps,
  GetColorAndVariantValuesProps,
} from "./button-link.type";

export const getColorAndVariantValues = ({
  type,
  color,
  variant,
}: GetColorAndVariantValuesProps) => {
  if (color && variant) return { color, variant };

  return {
    color: getColorValueFromType(type),
    variant: getVariantValueFromType(type),
  };
};

const getColorValueFromType = (type: ButtonLinkProps["type"]) => {
  // pick `type` values related to `color`
  if (type === "primary" || type === "default") {
    return type;
  }

  // fallback value like AntDesign `Button` behavior
  return "default";
};

const getVariantValueFromType = (type: ButtonLinkProps["type"]) => {
  // pick `type` values related to `variant`
  if (type === "dashed" || type === "link" || type === "text") {
    return type;
  }

  // fallback value like AntDesign `Button` behavior
  return type === "primary" ? "solid" : "outlined";
};
